import Vue from "vue";
import VTooltip from "v-tooltip";

Vue.use(VTooltip, {
  defaultDelay: {
    show: 500,
    hide: 300
  }
});
